import { createContext, useContext, useState, useMemo, useCallback } from "react";
import { BACKEND_URL, API_VERSION } from "@config/constants";

const ShopContext = createContext({
  shop: {},
  vendor: {},
  products: [],
  refresh: () => {},
  updateShop: () => {},
});

export const ShopProvider = ({ shop, children }) => {
  const [currentShop, setCurrentShop] = useState(shop && shop);
  const [loading, setLoading] = useState(false);

  const updateShop = useCallback((shop) => {
    setCurrentShop(shop);
    localStorage.setItem("shop", JSON.stringify(shop));
  }, []);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${BACKEND_URL}/${API_VERSION}/shopfront`);
      // console.log(res);
      if (res.status === 200) {
        let updatedShop = await res.json();
        delete updatedShop.vendor.user;
        delete updatedShop.vendor.bank_name;
        delete updatedShop.vendor.bank_account_number;
        updateShop(updatedShop);
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  }, [updateShop]);

  const contextValue = useMemo(
    () => ({
      shop: currentShop,
      vendor: currentShop?.vendor,
      products: currentShop?.products,
      loading,
      refresh,
      updateShop,
    }),
    [currentShop, loading, refresh, updateShop],
  );

  // console.log(currentShop);
  return <ShopContext.Provider value={contextValue}>{children}</ShopContext.Provider>;
};

const useShopContext = () => {
  return useContext(ShopContext);
};

export default useShopContext;
